export const INTERVAL_TO_TICKETS_RELOAD_MIN = 10;
